import React from "react";
import path from "path";

// Styles
import "./Icon.css";

function Icon({ item, isOpen = true, setIsOpen }) {
  const getFileIconClass = extn => {
    switch (extn) {
      case ".xls":
      case ".xlsx":
        return "fas fa-file-excel xls";
      case ".doc":
      case ".docx":
        return "fas fa-file-word doc";
      case ".jpg":
      case ".jpeg":
      case ".png":
      case ".tif":
      case ".tiff":
        return "fas fa-file-image image";
      case ".ppt":
      case ".pptx":
        return "fas fa-file-powerpoint ppt";
      case ".dwg":
        return "fas fa-file-medical-alt dwg";
      case ".csv":
        return "fas fa-file-csv csv";
      case ".pdf":
        return "fas fa-file-pdf pdf";
      default:
        return "fas fa-file xfile";
    }
  };

  return (
    <span className="pointer icon-node ml-10 pb-10">
      <span className="icon-wrapper ml-10 my-5">
        <i
          className={`icon-file cp ${getFileIconClass(
            path.extname(item.raw_filename)
          )}`}
        ></i>
      </span>

      <span onClick={() => setIsOpen(!isOpen)} className="ml-5">
        {item.raw_filename}
      </span>
    </span>
  );
}

export default Icon;
